import { reiniciarInterfaz } from "./cambiarEsquema"
import { reiniciarEsquema } from "./esquemaTablas"
import { refrescarBodegas } from "./listasBodegas"
import { refrescarListasPrecio } from "./listasPrecio"
const { Navigate } = require("react-router-dom")
const { default: guardarUsuario } = require("./guardarUsuario")

export const cerrarSesion = () => {
    return async dispatch => {
            dispatch(reiniciarEsquema())
            dispatch(guardarUsuario(false))
            dispatch(reiniciarInterfaz())
            dispatch(refrescarListasPrecio([]))
            dispatch(refrescarBodegas([]))
            return <Navigate to="/login" />
    }
}
